import React from "react";
import { ContentBlock } from "./content-block.component";

export function Info({ title, children }) {
  return (
    <ContentBlock
      title={title}
      children={children}
      icon="question"
      bgColor="bg-gray-100"
      textColor="text-gray-800"
    />
  );
}
